import React, {useContext, useEffect, useState} from 'react';
import ReactSelect from "react-select";

import * as ApiCalls from "../ApiCalls.js";

import "../../../style/PriorityTableStyles/taskstable.css";

import {azureTokenContext, userInfoContext} from "../../../App";
import {targetUserIdContext} from "../../MainPart";
import {useLogMetric} from "../../../hooks/useLogMetric";

export default function SelectTargetUser() {
    const azureToken = useContext(azureTokenContext);
    const [allUsersOptions, setAllUsersOptions] = useState<[]>([]);
    const [userInfo] = useContext(userInfoContext);
    const [targetUserId, setTargetUserId] = useContext(targetUserIdContext);
    const [allUsersLoaded, setAllUsersLoaded] = useState<boolean>(false);
    const logMetric = useLogMetric();

    useEffect(() => {
        if (userInfo?.IsKarnovEmployee) {
            ApiCalls.getAllUsers(azureToken)
                .then((res) => {
                    const sortedUsers = res.sort((a, b) => a.Name.localeCompare(b.Name));
                    setAllUsersOptions(
                        sortedUsers.map((user) => ({
                            value: user.Id,
                            label: user.Name,
                        }))
                    );
                    setAllUsersLoaded(true);
                })
                .catch((err) => {
                    console.error("Get All Users fail", err);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.Id]);

    const handleViewDropdownChange = (option: any) => {
        setTargetUserId(option.value);
        logMetric({category: "UserSelection", subCategory: "Target user changed", message: `User changed view to user: ${option.label}`});
    };

    const hideAsUserBox = () => {
        document.getElementsByClassName("user-select-container")[0].setAttribute("style", "display: none");
        logMetric({category: "UserSelection", subCategory: "Select box closed", message: "User closed the user select box"});
    }

    return (
        <div className="user-select-container mt-1">
            {userInfo?.IsKarnovEmployee && allUsersLoaded && (
                <div className="user-select-dropdown">
                    <label htmlFor="user-select">Ser som:</label>
                    <ReactSelect
                        id="user-select"
                        value={allUsersOptions.find((option: any) => option.value === targetUserId)}
                        onChange={(selectedOption) => handleViewDropdownChange(selectedOption)}
                        options={allUsersOptions}
                        isSearchable
                        placeholder="Velg person"
                        className="custom-select"
                    />
                    <button className="close-user-box-button" onClick={hideAsUserBox}>X</button>
                </div>
            )}
        </div>
    )
}